window.sq = window.sq || {};

["SwymViewProducts", "SwymWatchProducts", "SwymProductVariants"].forEach(function (t) {
    if (!window[t]) {
        window[t] = {};
    }
});

window.SwymCallbacks = window.SwymCallbacks || [];

window.SwymCallbacks.push(function (t) {
    document.addEventListener("swym:collection-loaded", function () {
        setTimeout(function () {
            t.initializeActionButtons("body");
        }, 500);
    });
});

function updateLoadMoreText() {
  const buttonText = document.querySelector(
    '.sq-pager-load-more > div'
  );

  if (
    buttonText &&
    buttonText.textContent.trim() !== 'Laad meer'
  ) {
    buttonText.textContent = 'Laad meer';
  }
}

window.addEventListener('load', function () {
  updateLoadMoreText();

  const observer = new MutationObserver(updateLoadMoreText);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.dispatchEvent(
    new CustomEvent('swym:collection-loaded')
  );
});

window.sq.onComplete = function () {
    document.dispatchEvent(new CustomEvent("swym:collection-loaded"));
};

(function (XHR) {
    "use strict";

    var originalOpen = XHR.prototype.open;
    var originalSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, async, user, pass) {
        this._url = url; // Save the URL for later use
        originalOpen.call(this, method, url, async, user, pass);
    };

    XHR.prototype.send = function (data) {
        var url = this._url;
        let location = window.location.href;
        
        if (url.toLowerCase() === "https://k1gs1z1m2q135r5cepzew6ux.fast.sparq.ai/v2".toLowerCase()) {
            let body;
            try {
                body = JSON.parse(data);
            } catch (error) {
                console.error("Error parsing XHR data as JSON:", error);
                // If parsing fails, just proceed to send the original data
                originalSend.call(this, data);
                return;
            }

            // Extract collection handle from URL if present
            let collectionHandle = location.includes("/collections/") ? location.split("/collections/")[1].split("?")[0] : null;

            // Proceed only if we're not on a search or all page and collectionHandle is found
            if (!location.includes("/search") && !location.includes("/all") && collectionHandle) {
                let collectionHandleFormatted = `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`;
                let sorting = body.sort || [];

                // Add collection-specific sortOrder if not already included
                if (!sorting.includes(collectionHandleFormatted)) {
                    sorting.push(collectionHandleFormatted);
                }

                // Update the sort order
                body.sort = sorting;

                // Convert the modified body back to a JSON string
                data = JSON.stringify(body);
            }
        }

        // Proceed to send the (possibly modified) data
        originalSend.call(this, data);
    };
})(XMLHttpRequest);



document.addEventListener("click", function (e) {

    // check if quantity button clicked
    if (!e.target.classList.contains("quantity-btn")) return;

    const container = e.target.closest(".quantity-container");
    const input = container.querySelector("input[name='quantity']");
    const buttons = container.querySelectorAll(".quantity-btn");

    // set default value
    if (!input.value) input.value = 1;

    let qty = parseInt(input.value);

    // first button = minus
    if (e.target === buttons[0]) {
        if (qty > 1) input.value = qty - 1;
    }

    // second button = plus
    if (e.target === buttons[1]) {
        input.value = qty + 1;
    }

});





